module.exports = ['$scope', '$ionicHistory', '$stateParams',
  function ($scope, $ionicHistory, $stateParams) {
    $scope.goBack = function() {
      const v = $ionicHistory.viewHistory()
      console.log($ionicHistory)
      if (!v.backView) {
        v.backView = v.currentView
        v.backView.stateId = 'frame.folder_fid=1'
        v.backView.stateName = 'frame.folder'
        v.backView.url = '/frame/folder/1'
        v.backView.stateParams = {
          fid: 1
        }
      }
      $ionicHistory.goBack(-1)
    }

    $scope.contactId = $stateParams.uid
    $scope.LOGIN_CLIENT = $stateParams.loginClient
    $scope.LOGIN_TIME = $stateParams.loginTime
  }]



// WEBPACK FOOTER //
// ./src/js/controllers/loginRemindingCtrl.js